import { render, staticRenderFns } from "./CorpTerritoryRanking.vue?vue&type=template&id=9c4e87d4&scoped=true&"
import script from "./CorpTerritoryRanking.vue?vue&type=script&lang=js&"
export * from "./CorpTerritoryRanking.vue?vue&type=script&lang=js&"
import style0 from "./CorpTerritoryRanking.vue?vue&type=style&index=0&id=9c4e87d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4e87d4",
  null
  
)

export default component.exports